module.exports = __webpack_public_path__ + "static/media/check_icon.5d9372e7.svg";